import { Apis, Enums, Helpers, Store } from "utils";
import { DocumentType } from "types";

export interface IQarePlanService {
  upsert(appointmentId: number, serviceId: number, providerId: number, diagnosisCodeId: number, message: string, secured: boolean, documents: DocumentType[]): Promise<any>;
  delete(appointmentId: number): Promise<any>;
  downloadDocument(appointmentId: number, documentName: string): Promise<any>;
}

export class QarePlanService implements IQarePlanService {
  private qubehub: any;
  private controllerName: string = "qareplan";

  constructor(accessToken: string) {
    this.qubehub = Apis.qubehub(accessToken);
  }

  async upsert(appointmentId: number, serviceId: number, providerId: number, diagnosisCodeId: number, message: string, secured: boolean, documents: DocumentType[]) {
    try {
      const formData = new FormData();
      const documentNames: string[] = [];

      documents.forEach((d) => (d.documentData ? formData.append("document", new Blob([d.documentData]), d.documentName) : documentNames.push(d.documentName)));

      formData.append("data", JSON.stringify({ serviceId, providerId, diagnosisCodeId, message, secured, documentNames }));
      return this.#handleResponse(await this.qubehub.post(Helpers.interpolateURL(this.controllerName + "/:appointmentId", { appointmentId }), formData));
    } catch (err: any) {
      console.log(err);
    }
    return null;
  }

  async delete(appointmentId: number) {
    try {
      return this.#handleResponse(await this.qubehub.delete(Helpers.interpolateURL(this.controllerName + "/:appointmentId", { appointmentId })));
    } catch (err: any) {
      console.log(err);
    }
  }

  async downloadDocument(appointmentId: number, documentName: string) {
    try {
      return this.#handleResponse(await this.qubehub.get(Helpers.interpolateURL(this.controllerName + "/download/:appointmentId/:documentName", { appointmentId, documentName })));
    } catch (err: any) {
      console.log(err);
    }
  }

  #handleResponse(response: any) {
    if (response && response.data) {
      const { status, payload } = response.data;
      if (Enums.EnumResponse.Unauthorized === status) Store.sessionStorage.clear();
      return payload ? [status, payload] : [status, null];
    }
    return [Enums.EnumResponse.None, null];
  }
}
